export default function updateDocumentData(firebase, { updatedBy = null, ...data }) {
	return {
		updated: firebase.firestore.FieldValue.serverTimestamp(),
		updatedBy,
		...data,
	};
}
